import React from 'react';
import { Details } from '../../components';
import { homeObjOne, homeObjThree } from './Data';

function SignUp() {
  return (
    <>
      <Details {...homeObjOne} />
      <Details {...homeObjThree} />
    </>
  );
}

export default SignUp;
